import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import Button from "../../../components/Button";

const NoOfficialColors = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - No Official Colors";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [dataForm, setDataForm] = useState({
    championship: "",
  });
  const [assignments, setAssignments] = useState<
    { username: string; assignment_id: number; logo: string; color: string }[]
  >([]);
  const [uploading, setUploading] = useState(false);
  const [data, setData] = useState<{
    drivers: {
      username: string;
      assignment_id: number;
      team_championship: number;
      logo: string | null;
      main_color: string | null;
    }[];
    champs: { id: number; name: string }[];
  }>();

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/team/getStandingsAssignments`,
        {
          params: { championship: dataForm.championship },
        },
      )
      .then(({ data }) => {
        setData(data);
        setAssignments(
          data.drivers.map((d: any) => ({
            username: d.username,
            team_championship_id: d.team_championship,
            logo: d.logo || "",
            color: d.main_color || "#000000",
          })),
        );
        if (dataForm.championship == "")
          setDataForm({
            ...dataForm,
            championship: data.champs[0].id.toString(),
          });
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        setUploading(false);
        throw new Error(response);
      });
  }, [dataForm.championship]);

  const inputChange = ({ target }: { target: any }) => {
    const { name, value } = target;
    setDataForm({
      ...dataForm,
      [name]: value,
    });
  };

  const submitForm = (event: any) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);
    formDataFiles.append("championship", dataForm.championship);
    formDataFiles.append("assignments", JSON.stringify(assignments));

    setUploading(true);
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/setTeamChampionshipValues`,
        formDataFiles,
      )
      .then(() => {
        toast.success("Colors assigned successfully");
        setUploading(false);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        setUploading(false);
      });
  };

  if (!access) return <ErrorPage />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="No Official Colors" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form onSubmit={submitForm}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Championship (*)</Form.Label>
              <Form.Select
                name="championship"
                value={dataForm.championship}
                required
                onChange={(e) => {
                  inputChange(e);
                }}
              >
                <option disabled value={""}>
                  None
                </option>
                {data?.champs.map((champ) => {
                  return (
                    <option value={champ.id} key={champ.id}>
                      {champ.name}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4">
              <b>Driver</b>
            </Form.Group>
            <Form.Group as={Col} md="4">
              <b>Logo</b>
            </Form.Group>
            <Form.Group as={Col} md="4">
              <b>Background Color</b>
            </Form.Group>
          </Row>
          {assignments.map((assignment, index) => (
            <Row key={assignment.assignment_id} className="mb-3">
              <Form.Group as={Col} md="4">
                <Form.Label>{assignment.username}</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Control
                  type="text"
                  value={assignment.logo}
                  onChange={(e) => {
                    const newAssignments = [...assignments];
                    newAssignments[index].logo = e.target.value;
                    setAssignments(newAssignments);
                  }}
                />
              </Form.Group>
              <Form.Group className="text-center" as={Col} md="4">
                <Form.Control
                  type="color"
                  value={assignment.color}
                  onChange={(e) => {
                    const newAssignments = [...assignments];
                    newAssignments[index].color = e.target.value;
                    setAssignments(newAssignments);
                  }}
                />
              </Form.Group>
            </Row>
          ))}
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button text={"Update"} type="submit" />
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NoOfficialColors;
